import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import logo from '../assets/logo.png';

const Navbar = ({ setCurrentPage }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleNavClick = (page) => {
    setCurrentPage(page);
    setIsOpen(false);
  };

  return (
    <nav className="bg-white shadow-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              {/* Logo */}
              <div className="h-16 w-48 relative py-2">
                <img src={logo} alt="InfAI Logo" className="h-full w-full object-contain" />
              </div>
            </div>

            {/* Desktop Navigation */}
            <div className="hidden md:ml-6 md:flex md:space-x-8">
              <button
                onClick={() => handleNavClick('home')}
                className="inline-flex items-center px-1 pt-1 text-gray-600 hover:text-teal-600"
              >
                Home
              </button>
              <button
                onClick={() => handleNavClick('about')}
                className="inline-flex items-center px-1 pt-1 text-gray-600 hover:text-teal-600"
              >
                About Us
              </button>
              <button
                onClick={() => handleNavClick('services')}
                className="inline-flex items-center px-1 pt-1 text-gray-600 hover:text-teal-600"
              >
                Services
              </button>
              <button
                onClick={() => handleNavClick('case-studies')}
                className="inline-flex items-center px-1 pt-1 text-gray-600 hover:text-teal-600"
              >
                Case Studies
              </button>
              <button
                onClick={() => handleNavClick('contact')}
                className="inline-flex items-center px-1 pt-1 text-gray-600 hover:text-teal-600"
              >
                Contact
              </button>
            </div>
          </div>

          {/* Mobile menu button */}
          <div className="flex items-center md:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="inline-flex items-center justify-center p-2 rounded-md text-gray-600 hover:text-teal-600 focus:outline-none"
            >
              {isOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {isOpen && (
        <div className="md:hidden">
          <div className="pt-2 pb-3 space-y-1">
            <button
              onClick={() => handleNavClick('home')}
              className="block w-full text-left pl-3 pr-4 py-2 text-base font-medium text-gray-600 hover:text-teal-600 hover:bg-gray-50"
            >
              Home
            </button>
            <button
              onClick={() => handleNavClick('about')}
              className="block w-full text-left pl-3 pr-4 py-2 text-base font-medium text-gray-600 hover:text-teal-600 hover:bg-gray-50"
            >
              About Us
            </button>
            <button
              onClick={() => handleNavClick('services')}
              className="block w-full text-left pl-3 pr-4 py-2 text-base font-medium text-gray-600 hover:text-teal-600 hover:bg-gray-50"
            >
              Services
            </button>
            <button
              onClick={() => handleNavClick('case-studies')}
              className="block w-full text-left pl-3 pr-4 py-2 text-base font-medium text-gray-600 hover:text-teal-600 hover:bg-gray-50"
            >
              Case Studies
            </button>
            <button
              onClick={() => handleNavClick('contact')}
              className="block w-full text-left pl-3 pr-4 py-2 text-base font-medium text-gray-600 hover:text-teal-600 hover:bg-gray-50"
            >
              Contact
            </button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
